
import { useState } from 'react';

interface FAQItem {
  category: string;
  question: string;
  answer: string;
}

const faqCategories = [
  { id: 'todos', label: 'Todas', icon: 'ri-list-check' },
  { id: 'general', label: 'General', icon: 'ri-question-line' },
  { id: 'preparacion', label: 'Preparación', icon: 'ri-calendar-check-line' },
  { id: 'cuidados', label: 'Cuidados', icon: 'ri-heart-pulse-line' },
  { id: 'precios', label: 'Precios', icon: 'ri-money-euro-circle-line' },
  { id: 'diseno', label: 'Diseño', icon: 'ri-brush-line' },
];

const faqs: FAQItem[] = [
  {
    category: 'general',
    question: '¿Duele hacerse un tatuaje?',
    answer:
      'Sí, pero la intensidad varía según la zona del cuerpo. Las áreas con más hueso y menos músculo (costillas, pies, manos, clavícula, columna) son más sensibles. Zonas como el antebrazo, el muslo o el hombro son mucho más tolerables. La mayoría de clientes describen la sensación como un rascado constante. Además, con el tiempo tu cuerpo libera endorfinas que ayudan a reducir la molestia.',
  },
  {
    category: 'general',
    question: '¿Qué edad mínima se necesita para tatuarse?',
    answer:
      'En España, la edad mínima legal para hacerse un tatuaje es de 18 años. Es obligatorio presentar el DNI o documento de identidad válido antes de la sesión. No se realizan tatuajes a menores de edad bajo ninguna circunstancia, ni siquiera con autorización de los padres.',
  },
  {
    category: 'general',
    question: '¿Es seguro hacerse un tatuaje?',
    answer:
      'Sí, siempre que se realice en un estudio profesional y certificado. En Daro Tattoo utilizamos exclusivamente material esterilizado y desechable: agujas de un solo uso, tintas homologadas por la UE, guantes nuevos para cada cliente y equipos de esterilización autoclave. Cumplimos con toda la normativa sanitaria vigente.',
  },
  {
    category: 'general',
    question: '¿Cuánto tarda en cicatrizar un tatuaje?',
    answer:
      'La cicatrización superficial tarda entre 2 y 3 semanas, durante las cuales verás costras y descamación. Sin embargo, la cicatrización completa de las capas profundas de la piel puede tardar entre 2 y 3 meses. Durante todo este periodo es fundamental seguir las instrucciones de cuidado que te proporcionamos.',
  },
  {
    category: 'general',
    question: '¿Se puede tapar un tatuaje viejo (cover-up)?',
    answer:
      'Sí, mediante la técnica de cover-up podemos transformar un tatuaje antiguo que ya no te guste en una nueva pieza. El diseño nuevo generalmente necesita ser más grande y con tonos más oscuros que el original. En la consulta previa evaluamos el tatuaje existente y te proponemos las mejores opciones de diseño.',
  },
  {
    category: 'general',
    question: '¿Los tatuajes se deforman con el tiempo?',
    answer:
      'Con los cuidados adecuados, un tatuaje bien hecho mantiene su forma durante décadas. Los factores que más afectan son la exposición solar sin protección, cambios bruscos de peso y la calidad de la tinta utilizada. Usar protector solar SPF 50+ sobre el tatuaje es clave para mantener los colores y la definición.',
  },
  {
    category: 'preparacion',
    question: '¿Cómo debo prepararme antes de la sesión?',
    answer:
      'Duerme bien la noche anterior, come una comida completa 1-2 horas antes de la cita, mantente bien hidratado y viste ropa cómoda que permita acceso fácil a la zona a tatuar. Puedes traer auriculares, un libro o tu móvil para entretenerte durante la sesión.',
  },
  {
    category: 'preparacion',
    question: '¿Qué cosas debo evitar antes de tatuarme?',
    answer:
      'No consumas alcohol ni drogas al menos 24 horas antes. Evita tomar aspirina o ibuprofeno (son anticoagulantes). No te broncees ni quemes la zona a tatuar los días previos. No te depiles con cera la zona (nosotros la rasuraremos). Evita llegar con la piel irritada o con heridas en la zona.',
  },
  {
    category: 'preparacion',
    question: '¿Puedo tatuarme si estoy embarazada o en periodo de lactancia?',
    answer:
      'No, por precaución no realizamos tatuajes a mujeres embarazadas ni en periodo de lactancia. Aunque no hay estudios concluyentes sobre riesgos directos, preferimos priorizar la seguridad tanto de la madre como del bebé. Te recomendamos esperar hasta finalizar la lactancia.',
  },
  {
    category: 'preparacion',
    question: '¿Puedo tatuarme si tengo alguna enfermedad de la piel?',
    answer:
      'Depende de la condición. Enfermedades como psoriasis, eczema o dermatitis pueden complicar la cicatrización. Si tienes alguna condición cutánea, te recomendamos consultarlo con tu dermatólogo antes y comentárnoslo en la consulta previa para evaluar tu caso particular.',
  },
  {
    category: 'preparacion',
    question: '¿Puedo tatuarme si tomo medicación?',
    answer:
      'Algunos medicamentos pueden afectar al proceso de tatuado y cicatrización, especialmente anticoagulantes, inmunosupresores y ciertos tratamientos para el acné como la isotretinoína. Infórmanos siempre de cualquier medicación que estés tomando para valorar si es seguro proceder.',
  },
  {
    category: 'cuidados',
    question: '¿Cómo debo cuidar mi tatuaje recién hecho?',
    answer:
      'Retira el film protector a las 2-4 horas. Lava suavemente con agua tibia y jabón neutro antibacterial 2-3 veces al día. Seca con toques suaves usando papel de cocina (nunca toalla de tela). Aplica una capa fina de crema regeneradora (tipo Bepanthen) 2-3 veces al día. No rasques ni arranques las costras que se formen.',
  },
  {
    category: 'cuidados',
    question: '¿Puedo bañarme en la playa o piscina con un tatuaje nuevo?',
    answer:
      'No. Debes evitar piscinas, playa, jacuzzis y baños prolongados durante al menos 2-3 semanas. El cloro, la sal y las bacterias del agua pueden provocar infecciones y dañar la tinta. Las duchas cortas están bien, pero evita que el chorro de agua caiga directamente sobre el tatuaje.',
  },
  {
    category: 'cuidados',
    question: '¿Puedo hacer deporte después de tatuarme?',
    answer:
      'Se recomienda evitar ejercicio intenso durante los primeros 5-7 días. El sudor excesivo puede irritar la zona y favorecer infecciones. Actividades suaves como caminar están bien desde el primer día. Evita especialmente ejercicios que estiren o friccionen la zona tatuada.',
  },
  {
    category: 'cuidados',
    question: '¿Puedo exponer mi tatuaje al sol?',
    answer:
      'Durante la cicatrización (primeras 3-4 semanas), evita completamente la exposición solar directa. Una vez cicatrizado, aplica siempre protector solar SPF 50+ sobre el tatuaje antes de exponerte al sol. Los rayos UV son el principal enemigo de los tatuajes: decoloran la tinta y difuminan los detalles.',
  },
  {
    category: 'cuidados',
    question: '¿Qué hago si mi tatuaje se infecta?',
    answer:
      'Los signos de infección incluyen enrojecimiento excesivo, hinchazón que no baja, pus, fiebre o dolor intenso. Si notas alguno de estos síntomas, contacta con nosotros inmediatamente y acude a tu médico. No te automediques. Siguiendo nuestras instrucciones de cuidado, las infecciones son extremadamente raras.',
  },
  {
    category: 'cuidados',
    question: '¿Necesitaré retoques después?',
    answer:
      'En la mayoría de casos no es necesario si sigues bien los cuidados. Sin embargo, algunas zonas del cuerpo (dedos, manos, pies) o pieles muy claras pueden necesitar un retoque menor. En Daro Tattoo ofrecemos un retoque gratuito dentro de los primeros 3 meses si fuera necesario.',
  },
  {
    category: 'precios',
    question: '¿Cuánto cuesta un tatuaje?',
    answer:
      'El precio depende del tamaño, complejidad, estilo y ubicación. Los tatuajes pequeños y sencillos parten desde 60-80€. Piezas medianas con detalle pueden oscilar entre 150-350€. Trabajos grandes como medias mangas o piezas de espalda se presupuestan por sesión. Cada proyecto es único, por eso ofrecemos presupuesto personalizado sin compromiso.',
  },
  {
    category: 'precios',
    question: '¿Hay que dejar señal para reservar?',
    answer:
      'Sí, para confirmar tu cita se requiere una señal que se descuenta del precio final del tatuaje. Esta señal garantiza tu reserva y cubre el tiempo de diseño personalizado. En caso de cancelación con más de 48 horas de antelación, la señal es reembolsable.',
  },
  {
    category: 'precios',
    question: '¿Qué formas de pago aceptáis?',
    answer:
      'Aceptamos efectivo, tarjeta de crédito/débito y Bizum. El pago se realiza una vez finalizada la sesión. Para tatuajes que requieren varias sesiones, el pago se divide por sesión.',
  },
  {
    category: 'precios',
    question: '¿El diseño personalizado tiene coste adicional?',
    answer:
      'No. El diseño está incluido en el precio del tatuaje. Trabajamos contigo desde la idea inicial hasta el boceto final, con las revisiones necesarias para que quedes completamente satisfecho antes de tatuar. Solo cobramos el diseño si finalmente decides no hacerte el tatuaje.',
  },
  {
    category: 'precios',
    question: '¿Cuánto dura una sesión de tatuaje?',
    answer:
      'Depende del tamaño y complejidad. Un tatuaje pequeño puede completarse en 1-2 horas. Piezas medianas suelen requerir 3-5 horas. Trabajos grandes como mangas completas o espaldas se dividen en varias sesiones de 4-6 horas cada una, con descansos entre sesiones de 3-4 semanas.',
  },
  {
    category: 'diseno',
    question: '¿Puedo llevar mi propio diseño?',
    answer:
      'Por supuesto. Puedes traer tu diseño, boceto, foto de referencia o simplemente una idea. Lo adaptaremos para que funcione perfectamente como tatuaje, respetando tu visión original. También puedes enviarnos referencias de Pinterest, Instagram o cualquier imagen que te inspire.',
  },
  {
    category: 'diseno',
    question: '¿En qué estilos os especializáis?',
    answer:
      'Nuestra especialidad principal es el Realismo y Mini Realismo en Black & Grey. También trabajamos estilos como geométrico, minimalista, lettering, neo-tradicional y cover-ups. Si tienes un estilo específico en mente, consúltanos y te asesoraremos sobre las mejores opciones.',
  },
  {
    category: 'diseno',
    question: '¿Podéis copiar exactamente un tatuaje que he visto?',
    answer:
      'No copiamos tatuajes de otros artistas por respeto profesional y ética. Sin embargo, podemos usar referencias como inspiración para crear un diseño único y personalizado para ti. Cada tatuaje que hacemos es una pieza original adaptada a tu cuerpo y estilo.',
  },
  {
    category: 'diseno',
    question: '¿Me ayudáis a elegir la zona del cuerpo?',
    answer:
      'Sí, te asesoramos sobre la mejor ubicación según el diseño, tamaño y tu anatomía. Algunos diseños funcionan mejor en ciertas zonas por la forma del músculo, el movimiento de la piel y la visibilidad. En la consulta previa te mostramos cómo quedaría el diseño en diferentes ubicaciones.',
  },
  {
    category: 'diseno',
    question: '¿Cuánto tiempo tardáis en preparar el diseño?',
    answer:
      'Normalmente entre 3 y 7 días laborables, dependiendo de la complejidad. Te enviamos el boceto antes de la cita para que puedas revisarlo y pedir cambios. No tatuamos hasta que estés 100% satisfecho con el diseño final.',
  },
];

export default function FAQSection() {
  const [activeCategory, setActiveCategory] = useState('todos');
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const filteredFaqs =
    activeCategory === 'todos' ? faqs : faqs.filter((faq) => faq.category === activeCategory);

  const toggleFaq = (index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section id="faq" className="py-16 md:py-28 relative" style={{ backgroundColor: '#141414' }}>
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage:
            'url("data:image/svg+xml,%3Csvg width=\'40\' height=\'40\' viewBox=\'0 0 40 40\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'%23ffffff\' fill-opacity=\'1\'%3E%3Cpath d=\'M20 20h20v20H20zM0 0h20v20H0z\'/%3E%3C/g%3E%3C/svg%3E")',
        }}
      ></div>

      <div className="max-w-5xl mx-auto px-4 md:px-8 relative z-10">
        {/* Header */}
        <div className="text-center mb-10 md:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-neutral-800 border border-neutral-700 rounded-full mb-6">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-question-answer-line text-amber-500"></i>
            </div>
            <span className="text-neutral-400 text-xs uppercase tracking-widest font-medium">
              Resolvemos tus dudas
            </span>
          </div>

          <h2
            className="text-[44px] sm:text-[60px] md:text-[80px] leading-none font-bold text-white mb-4 md:mb-6"
            style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '6px' }}
          >
            PREGUNTAS FRECUENTES
          </h2>
          <p className="text-neutral-400 text-sm md:text-base max-w-2xl mx-auto">
            Todo lo que necesitas saber antes de hacerte un{' '}
            <strong className="text-white">tatuaje profesional</strong>. Si no encuentras tu
            respuesta, no dudes en contactarnos.
          </p>
        </div>

        {/* Category Filters */}
        <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-8 md:mb-12">
          {faqCategories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => {
                setActiveCategory(cat.id);
                setOpenIndex(null);
              }}
              className={`flex items-center gap-2 px-4 py-2.5 text-xs md:text-sm font-medium transition-all cursor-pointer whitespace-nowrap border ${
                activeCategory === cat.id
                  ? 'bg-amber-600 border-amber-500 text-white'
                  : 'bg-neutral-800/80 border-neutral-700 text-neutral-400 hover:border-neutral-500 hover:text-neutral-200'
              }`}
              style={{
                clipPath:
                  'polygon(8px 0, 100% 0, 100% calc(100% - 8px), calc(100% - 8px) 100%, 0 100%, 0 8px)',
              }}
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className={`${cat.icon} text-sm`}></i>
              </div>
              {cat.label}
            </button>
          ))}
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-3">
          {filteredFaqs.map((faq, index) => {
            const isOpen = openIndex === index;
            const categoryData = faqCategories.find((c) => c.id === faq.category);

            return (
              <div
                key={`${activeCategory}-${index}`}
                className={`border transition-all duration-300 ${
                  isOpen
                    ? 'bg-neutral-800/90 border-amber-500/40'
                    : 'bg-neutral-900/60 border-neutral-800 hover:border-neutral-700'
                }`}
                style={{
                  clipPath:
                    'polygon(0 0, 100% 0, 100% calc(100% - 12px), calc(100% - 12px) 100%, 0 100%)',
                }}
              >
                <button
                  onClick={() => toggleFaq(index)}
                  className="w-full flex items-center gap-3 md:gap-4 px-5 md:px-7 py-4 md:py-5 text-left cursor-pointer group"
                >
                  <div
                    className={`w-8 h-8 md:w-9 md:h-9 flex items-center justify-center flex-shrink-0 transition-colors ${
                      isOpen ? 'bg-amber-600' : 'bg-neutral-800 group-hover:bg-neutral-700'
                    }`}
                    style={{
                      clipPath:
                        'polygon(0 0, 100% 0, 100% calc(100% - 6px), calc(100% - 6px) 100%, 0 100%)',
                    }}
                  >
                    <i
                      className={`${
                        categoryData?.icon || 'ri-question-line'
                      } text-sm md:text-base ${isOpen ? 'text-white' : 'text-neutral-500'}`}
                    ></i>
                  </div>

                  <span
                    className={`flex-1 text-sm md:text-base font-medium transition-colors ${
                      isOpen ? 'text-white' : 'text-neutral-300 group-hover:text-white'
                    }`}
                  >
                    {faq.question}
                  </span>

                  <div
                    className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${
                      isOpen ? 'rotate-45' : ''
                    }`}
                  >
                    <i
                      className={`ri-add-line text-lg ${isOpen ? 'text-amber-500' : 'text-neutral-600'}`}
                    ></i>
                  </div>
                </button>

                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    isOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="px-5 md:px-7 pb-5 md:pb-6 pl-16 md:pl-20">
                    <div className="w-12 h-px bg-amber-500/30 mb-4"></div>
                    <p className="text-neutral-400 text-sm leading-relaxed">{faq.answer}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Counter */}
        <div className="text-center mt-6 md:mt-8">
          <span className="text-neutral-600 text-xs">
            Mostrando {filteredFaqs.length} de {faqs.length} preguntas
          </span>
        </div>

        {/* CTA */}
        <div
          className="mt-10 md:mt-16 bg-neutral-800/50 border border-neutral-700 p-6 md:p-10 text-center"
          style={{
            clipPath:
              'polygon(0 0, 100% 0, 100% calc(100% - 20px), calc(100% - 20px) 100%, 0 100%)',
          }}
        >
          <div
            className="w-12 h-12 md:w-14 md:h-14 bg-amber-600/20 flex items-center justify-center mx-auto mb-4"
            style={{
              clipPath:
                'polygon(0 0, 100% 0, 100% calc(100% - 10px), calc(100% - 10px) 100%, 0 100%)',
            }}
          >
            <i className="ri-chat-smile-2-line text-2xl md:text-3xl text-amber-500"></i>
          </div>
          <h3
            className="text-xl md:text-2xl font-bold text-white mb-3"
            style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '2px' }}
          >
            ¿TIENES MÁS PREGUNTAS?
          </h3>
          <p className="text-neutral-400 text-sm mb-6 max-w-lg mx-auto">
            Escríbenos por Instagram o rellena el formulario de contacto y te responderemos lo antes
            posible
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <a
              href="https://www.instagram.com/Daro_tattoo_"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 bg-amber-600 text-white text-sm font-medium hover:bg-amber-500 transition-all cursor-pointer whitespace-nowrap"
              style={{
                clipPath:
                  'polygon(8px 0, 100% 0, 100% calc(100% - 8px), calc(100% - 8px) 100%, 0 100%, 0 8px)',
              }}
            >
              <i className="ri-instagram-line text-lg"></i>
              ESCRÍBENOS POR INSTAGRAM
            </a>
            <button
              onClick={() => {
                const el = document.getElementById('reservar');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-2 px-6 py-3 bg-neutral-700 text-white text-sm font-medium hover:bg-neutral-600 transition-all cursor-pointer whitespace-nowrap border border-neutral-600"
              style={{
                clipPath:
                  'polygon(8px 0, 100% 0, 100% calc(100% - 8px), calc(100% - 8px) 100%, 0 100%, 0 8px)',
              }}
            >
              <i className="ri-calendar-line text-lg"></i>
              RESERVAR CITA
            </button>
          </div>
        </div>
      </div>

      {/* Schema.org FAQPage structured data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }),
        }}
      />
    </section>
  );
}
